// The Sales Planning guide (54_SalesPlanning.jsx · ModuleHelp, Max 01/11). One guide for all six Sales Planning screens.
const en = {
  orderT: 'The order you are working on',
  orderB: 'Pick the order here. Next to it you see its order due date, ex-factory date and whether it is open or closed. Order Format and Setup have no order bar.',
  stepsT: 'The four steps of an order',
  stepsB: 'Order format, order sheets, stock and production, each with how far it has got. Click a step to open its screen, if your role may.',
  toolbarT: 'Filters and actions',
  toolbarB: 'The bar above the list holds this screen\'s filters, counts and buttons, such as a new order, the SAP upload file or an import.',
  tableT: 'The list',
  tableB: 'The main list of this screen: orders, buyer sheets, SKUs or buyers. Open a row for its details; Sales Planning applies the rules the server sends and does not decide them.',
};
const ko = {
  orderT: '작업 중인 오더',
  orderB: '여기서 오더를 고릅니다. 옆에 주문 마감일, 출고 예정일(ex-factory), 진행/마감 상태가 보입니다. Order Format과 Setup에는 오더 바가 없습니다.',
  stepsT: '오더의 네 단계',
  stepsB: '오더 포맷, 오더 시트, 재고, 생산이며 각각의 진행 정도가 표시됩니다. 권한이 있으면 단계를 클릭해 해당 화면으로 이동합니다.',
  toolbarT: '필터와 동작',
  toolbarB: '목록 위 바에 이 화면의 필터, 건수, 버튼(새 오더, SAP 업로드 파일, 가져오기 등)이 있습니다.',
  tableT: '목록',
  tableB: '이 화면의 주 목록으로 오더, 바이어 시트, SKU 또는 바이어가 나옵니다. 행을 열어 상세를 확인하세요. 규칙은 서버가 정하며 화면은 그대로 보여줍니다.',
};
const vi = {
  orderT: 'Đơn bạn đang làm',
  orderB: 'Chọn đơn ở đây. Bên cạnh là hạn đặt hàng, ngày ex-factory và đơn đang mở hay đã đóng. Order Format và Setup không có thanh này.',
  stepsT: 'Bốn bước của một đơn',
  stepsB: 'Order format, order sheets, stock và production, mỗi bước kèm mức đã làm xong. Bấm vào một bước để mở màn hình đó, nếu role của bạn được phép.',
  toolbarT: 'Bộ lọc và thao tác',
  toolbarB: 'Thanh phía trên danh sách có bộ lọc, số đếm và các nút của màn hình này, như tạo đơn mới, file upload SAP hoặc import.',
  tableT: 'Danh sách',
  tableB: 'Danh sách chính của màn hình: đơn, sheet của buyer, SKU hoặc buyer. Mở một dòng để xem chi tiết; luật do server quyết định, màn hình chỉ hiển thị.',
};
const zh = {
  orderT: '你正在处理的订单',
  orderB: '在这里选择订单。旁边显示下单截止日、ex-factory 日期以及订单是开放还是已关闭。Order Format 和 Setup 没有订单栏。',
  stepsT: '订单的四个步骤',
  stepsB: 'Order format、order sheets、stock 和 production，每一步都显示完成进度。如果你的角色有权限，点击某一步即可打开对应页面。',
  toolbarT: '筛选与操作',
  toolbarB: '列表上方的栏里有本页面的筛选、数量和按钮，例如新建订单、SAP 上传文件或导入。',
  tableT: '列表',
  tableB: '本页面的主列表：订单、买家表、SKU 或买家。打开一行查看详情；规则由服务器决定，页面只负责显示。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "orderT": "La commande en cours",
  "orderB": "Choisissez la commande ici. À côté, vous voyez son échéance de commande, sa date ex-factory et si elle est ouverte ou clôturée. Format de commande et Configuration n'ont pas de barre de commande.",
  "stepsT": "Les quatre étapes d'une commande",
  "stepsB": "Format de commande, feuilles de commande, stock et production, chacune avec son avancement. Cliquez sur une étape pour ouvrir son écran, si votre rôle le permet.",
  "toolbarT": "Filtres et actions",
  "toolbarB": "La barre au-dessus de la liste contient les filtres, les compteurs et les boutons de cet écran, comme une nouvelle commande, le fichier d'import SAP ou un import.",
  "tableT": "La liste",
  "tableB": "La liste principale de cet écran : commandes, feuilles d'acheteurs, SKU ou acheteurs. Ouvrez une ligne pour ses détails ; Sales Planning applique les règles envoyées par le serveur et ne les décide pas."
};
const ja = {
  "orderT": "作業中の注文",
  "orderB": "ここで注文を選択します。横に、注文期日、ex-factory 日、オープンかクローズかが表示されます。「注文フォーマット」と「設定」には注文バーはありません。",
  "stepsT": "注文の4つのステップ",
  "stepsB": "注文フォーマット、注文シート、在庫、生産の4つで、それぞれの進捗が表示されます。ロールで許可されている場合は、ステップをクリックしてその画面を開きます。",
  "toolbarT": "フィルターと操作",
  "toolbarB": "リストの上のバーに、この画面のフィルター、件数、ボタン（新規注文、SAP アップロードファイル、インポートなど）があります。",
  "tableT": "リスト",
  "tableB": "この画面のメインのリストで、注文、バイヤーシート、SKU、バイヤーのいずれかです。行を開くと詳細が表示されます。Sales Planning はサーバーから送られるルールを適用するだけで、ルールを決めることはありません。"
};

const dictionary = { ns: 'tourSalesPlanning', en, ko, vi, zh, fr, ja };
export default dictionary;
